import { RouteObject } from "react-router-dom";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ArticleDetailPage from "@/pages/article-detail/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/pandabuy-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/article/:slug",
    element: <ArticleDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;